<div class="page-content">
    <div class="page-header">
        <h1>Simulez vos réseaux de chaleur</h1>
        <!-- <div class="page-description">
            Charger le fichier géopackage et les paramètres pour réaliser votre simulation
        </div> -->
    </div>

    <div class="page-body">
        <div class="settings-menu">
            <div
                *ngFor="let item of menuItems$ | async"
                class="settings-item"
                [routerLink]="item.routerLink"
                routerLinkActive="selected"
                [routerLinkActiveOptions]="item.routerLinkActiveOptions">
                {{ item.display }}
            </div>
        </div>
        <router-outlet></router-outlet>
    </div>
</div>
